import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { REVENUE_PATH, canSeeOpportunities } from '../utils/revenueLinks';
import './RevenueBackBar.css';

function dollars(cents: number): string {
  return `$${Math.round(cents / 100).toLocaleString('en-US')}`;
}

// Sits above the Audiences workspace when it is opened from the Revenue page:
// says which weak block the list is for, and leads back. A venue that only
// has Audiences has no Revenue page to go back to, so it sees nothing.
export default function RevenueBackBar({ block, riskCents }: { block: string | null; riskCents: number | null }) {
  const { isSuperAdmin } = useAuth();
  if (!canSeeOpportunities(isSuperAdmin)) return null;

  return (
    <div className="revenue-back-bar">
      <Link to={REVENUE_PATH} className="revenue-back-bar__back">
        <span aria-hidden="true">←</span> Growth
      </Link>
      {block && (
        <p className="revenue-back-bar__block">
          Finding players for <strong>{block}</strong>
          {riskCents !== null && <span className="revenue-back-bar__risk">{dollars(riskCents)} at risk</span>}
        </p>
      )}
    </div>
  );
}
